import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ShowDialogsComponent} from 'src/app/components/show-dialogs/show-dialogs.component';
import {MarketplaceManagerService} from 'src/app/services/marketplace-manager.service';
import {SharedFeaturesService} from 'src/app/services/shared-features.service';
import {SolutionsAppService} from 'src/app/services/solutions-app.service';
import {
  DeploySolutionFormComponent
} from '../../../sales-dna/components/deploy-solution-form/deploy-solution-form.component';
import {GenSubscriptionKeyComponent} from '../gen-subscription-key/gen-subscription-key.component';
import {
  VersionDocsDialogComponent
} from '../../../sales-dna/components/version-documentation/version-docs-dialog.component';
import {ViewSubscriptionKeyComponent} from '../view-subscription-key/view-subscription-key.component';

@Component({
  selector: 'app-marketplace-manager',
  template: `
    <div class="mm-page">
      <div class="content">
        <div class="pagehead">
          <h1>Manage marketplace</h1>
          <p>Publish your solution versions and manage who can subscribe.</p>
        </div>

        <div class="sol-card" *ngFor="let solution of solutionsInProduction">
          <div class="sol-head">
            <div class="sol-ico"><mat-icon>hub</mat-icon></div>
            <div class="sol-mid">
              <div class="sol-nm">
                <span
                  matTooltip="{{ solution['solution_name'] | textpretty | titlecase }}"
                >{{ solution['solution_name'] | textpretty | titlecase | namingsize : 40 }}</span>
                <span class="pubbadge pb-live" *ngIf="getMarketSoln(solution)">
                  <mat-icon>check</mat-icon> Published</span>
                <span class="pubbadge pb-off" *ngIf="!getMarketSoln(solution)">Not published</span>
              </div>
              <div class="sol-desc" *ngIf="solnDesc(solution)">{{ solnDesc(solution) }}</div>
              <div class="deploy" *ngIf="getMarketSoln(solution)">
                <span class="lbl">Available to:</span>
                <ng-container *ngIf="deployFor(solution).length; else noDeploy">
                  <span class="tchip" *ngFor="let t of deployFor(solution)">{{ t }}</span>
                </ng-container>
                <ng-template #noDeploy><span class="tchip muted">Not set</span></ng-template>
                <button class="btn-ghost xs" (click)="synopsisData(solution)">
                  <mat-icon>edit</mat-icon> Change</button>
              </div>
            </div>
            <div class="sol-actions" *ngIf="getMarketSoln(solution)">
              <button class="btn-ghost" (click)="synopsisData(solution)">
                <mat-icon>edit</mat-icon> Edit details</button>
              <button class="btn-ghost" (click)="openDialogToGenToken(solution)">
                <mat-icon>vpn_key</mat-icon> Generate key</button>
              <button class="btn-ghost" (click)="openDialogToViewToken(solution)">
                <mat-icon>group</mat-icon> Subscribers</button>
            </div>
          </div>

          <div class="ver-wrap">
            <div class="ver-lbl">Versions</div>
            <div
              class="ver-row"
              *ngFor="let version of versionsInASolution[solution['solution_id']]"
            >
              <span class="vbadge">{{ version['version_name'] }}</span>
              <div class="ver-mid"><span class="ver-when">{{ verWhen(version) }}</span></div>
              <span class="st-pill st-pub" *ngIf="isVersionPublished(version)">Published</span>
              <span class="st-pill st-draft" *ngIf="!isVersionPublished(version)">Draft</span>
              <button class="btn-ghost" (click)="openDocsDialog(solution, version)">
                <mat-icon>menu_book</mat-icon> Docs</button>
              <button
                class="btn-ghost danger"
                *ngIf="isVersionPublished(version)"
                (click)="deleteVersionFromMarket(version)"
              ><mat-icon>arrow_downward</mat-icon> Unpublish</button>
              <button
                class="btn-primary"
                *ngIf="!isVersionPublished(version)"
                (click)="pushVersionInMarket(solution, version)"
              ><mat-icon>arrow_upward</mat-icon> Publish</button>
            </div>
            <div
              class="proj-empty"
              *ngIf="!versionsInASolution[solution['solution_id']]?.length"
            >No versions yet.</div>
          </div>
        </div>

        <div class="ver-empty" *ngIf="solutionsInProduction && !solutionsInProduction.length">
          No solutions in production yet.
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./marketplace-manager.component.scss'],
})
export class MarketplaceManagerComponent implements OnInit {
  solutionsInProduction: any;
  solutionsIsMarketplace: any;
  versionInMarketPlace: any;
  versionsInASolution: any = {};
  availableTenant: any = [];

  constructor(
    private solutionServices: SolutionsAppService,
    private marketplaceServices: MarketplaceManagerService,
    private dialog: MatDialog,
    private snackBar: SharedFeaturesService,
    private detectChange: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.marketplaceServices.getAllSolutionsInProduction().subscribe({
      next: (response: any) => {
        this.solutionsInProduction = response['msg'];
        for (const soln of response['msg']) {
          const solutionId = soln.solution_id;

          this.getVersion(soln)
            .then((result: any) => {
              this.versionsInASolution[solutionId] = result;
            })
            .catch((error) => {
              this.versionsInASolution[solutionId] = [];
            });
        }
      },
    });

    this.fetchSolutionFromMarket();
  }

  fetchSolutionFromMarket() {
    this.marketplaceServices.getSolutionInMarket().subscribe({
      next: (response: any) => {
        if (response) {
          this.solutionsIsMarketplace = response['msg'];
          this.fetchVersionFromMarket();
        }
      },
      error: (error: any) => {
        console.error('error', error);
        this.solutionsIsMarketplace = [];
      },
    });
  }

  fetchVersionFromMarket() {
    this.marketplaceServices.getVersionInMarket().subscribe({
      next: (response: any) => {
        this.versionInMarketPlace = response['msg'];
      },

      error: (error: any) => {
        console.error('error', error);
        this.versionInMarketPlace = [];
      },
    });
  }

  getVersion(solution: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.solutionServices.getAvailableVersion(solution).subscribe({
        next: (response: any) => {
          resolve(this.getLatestVersion(response));
        },
        error: (error: any) => {
          reject([]);
        },
      });
    });
  }

  getLatestVersion(data: any[]) {
    data.sort((a, b) => {
      // Assuming version_name is in the format "Vx", where x is a number.
      const versionA = parseInt(a.version_name.substr(1));
      const versionB = parseInt(b.version_name.substr(1));
      return versionB - versionA;
    });
    return data; // change here to show all version avl return data
  }

  pushVersionInMarket(solution: any, version: any) {
    const dataSolution = {
      solution_id: solution['solution_id'],
      solution_name: solution['solution_name'],
      created_dtm: solution['created_dtm'],
      updated_dtm: solution['updated_dtm'],
      is_active: solution['is_active'],
      user_facing_solution_desc: {},
      deploy_for: ['ALL'],
    };
    const dataVersion = {
      solution_id: solution['solution_id'],
      version_id: version['version_id'],
      version_name: version['version_name'],
      created_dtm: version['created_dtm'],
      version_owner: version['version_owner'],
      solution_name: solution['solution_name'],
      updated_dtm: version['updated_dtm'],
      stage: version['stage'],
      is_active: version['is_active'],
    };

    const soln = this.keyValueExists(
      'solution_id',
      solution['solution_id'],
      this.solutionsIsMarketplace
    );

    if (soln) {
      const deployForm = this.dialog.open(DeploySolutionFormComponent, {
        data: soln,
        panelClass: 'edit-details-dialog',
        width: '640px',
        maxWidth: '94vw',
        disableClose: false,
      });
      deployForm.afterClosed().subscribe((result) => {
        if (result) {
          soln['deploy_for'] = result['deploy_for'];
          delete result['deploy_for'];
          soln['user_facing_solution_desc'] = result;
          this.marketplaceServices.updateSolutionInMarket(soln).subscribe({
            next: () => {
            },
            error: (error: any) => {
              console.error(error);
            },
          });
          this.pushVersion(dataVersion);
        }
      });
    } else {
      const deployForm = this.dialog.open(DeploySolutionFormComponent, {
        data: solution,
        panelClass: 'edit-details-dialog',
        width: '640px',
        maxWidth: '94vw',
      });
      deployForm.afterClosed().subscribe((result) => {
        if (result) {
          dataSolution['deploy_for'] = result['deploy_for'];
          delete result['deploy_for'];
          dataSolution.user_facing_solution_desc = result;
          this.marketplaceServices
            .pushSolutionIntoMarket(dataSolution)
            .subscribe({
              next: (response: any) => {
                this.pushVersion(dataVersion);
              },
              error: (error: any) => {
                console.error(error);
              },
            });
        }
      });
    }
  }

  synopsisData(solution: any) {
    const dataSolution: any = {
      solution_id: solution['solution_id'],
      solution_name: solution['solution_name'],
      created_dtm: solution['created_dtm'],
      updated_dtm: solution['updated_dtm'],
      is_active: solution['is_active'],
      user_facing_solution_desc: {},
    };
    const soln = this.keyValueExists(
      'solution_id',
      solution['solution_id'],
      this.solutionsIsMarketplace
    );

    if (soln) {
      const deployForm = this.dialog.open(DeploySolutionFormComponent, {
        data: soln,
        panelClass: 'edit-details-dialog',
        width: '640px',
        maxWidth: '94vw',
        disableClose: false,
      });
      deployForm.afterClosed().subscribe((result) => {
        if (result) {
          dataSolution['deploy_for'] = result['deploy_for'];
          delete result['deploy_for'];
          dataSolution.user_facing_solution_desc = result;
          this.marketplaceServices.updateSolutionInMarket(dataSolution).subscribe({
            next: (result: any) => {
              this.detectChange.detectChanges();
              this.snackBar.openSnackBar(
                result['msg'],
                'Close',
                'success-snackbar'
              );
              this.fetchSolutionFromMarket();
            },
            error: (error: any) => {
              this.snackBar.openSnackBar(
                error['msg'],
                'Close',
                'error-snackbar'
              );
            },
          });
        }
      });
    } else {
      const deployForm = this.dialog.open(DeploySolutionFormComponent, {
        data: solution,
        panelClass: 'edit-details-dialog',
        width: '640px',
        maxWidth: '94vw',
        disableClose: false,
      });
      deployForm.afterClosed().subscribe((result) => {
        if (result) {
          dataSolution['deploy_for'] = result['deploy_for'];
          delete result['deploy_for'];
          dataSolution.user_facing_solution_desc = result;
          this.marketplaceServices
            .pushSolutionIntoMarket(dataSolution)
            .subscribe({
              next: (response: any) => {
                this.fetchSolutionFromMarket();
                this.detectChange.detectChanges();
              },
              error: (error: any) => {
                console.error('got error in saving solution', error);
              },
            });
        }
      });
    }
  }

  pushVersion(dataVersion: any) {
    this.marketplaceServices.pushVersionInMarket(dataVersion).subscribe({
      next: (result: any) => {
        this.fetchSolutionFromMarket();
        this.detectChange.detectChanges();
        this.snackBar.openSnackBar(result['msg'], 'Close', 'success-snackbar');
      },
      error: (error: any) => {
        this.snackBar.openSnackBar(
          error.error['msg'],
          'Close',
          'error-snackbar'
        );
      },
    });
  }

  deleteVersionFromMarket(version: any) {
    const deleteConfirmation = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Remove version from marketplace?',
        message:
          'Consumers will no longer be able to subscribe to this version. Existing subscribers are not affected.',
        confirmText: 'Remove',
        cancelText: 'Cancel',
        danger: true,
      },
      disableClose: false,
    });
    deleteConfirmation.afterClosed().subscribe((result) => {
      if (result) {
        this.marketplaceServices
          .deleteVersionFromMarketplace(version)
          .subscribe({
            next: (response: any) => {
              this.fetchSolutionFromMarket();
              this.detectChange.detectChanges();
              this.snackBar.openSnackBar(
                response['msg'],
                'Close',
                'success-snackbar'
              );
            },
            error: (error: any) => {
              this.snackBar.openSnackBar(
                error.error.msg,
                'Close',
                'error-snackbar'
              );
            },
          });
      }
    });
  }

  clearMissingSolutions() {
    const solutionIds1 = this.solutionsIsMarketplace.map(
      (item: any) => item.solution_id
    );
    const solutionIds2 = this.versionInMarketPlace.map(
      (item: any) => item.solution_id
    );

    const missingSolutions = this.solutionsIsMarketplace.filter(
      (item: any) => !solutionIds2.includes(item.solution_id)
    );

    for (let solution of missingSolutions) {
      this.marketplaceServices
        .deleteSolutionFromMarketplace(solution)
        .subscribe({
          next: (response: any) => {
          },
          error: (error: any) => {
          },
        });
    }
  }

  keyValueExists(key: string, value: any, data: any): any | boolean {
    const result = (data || []).find((item: any) => item[key] === value);
    return result ? result : false;
  }

  getMarketSoln(solution: any): any | boolean {
    return this.keyValueExists(
      'solution_id',
      solution['solution_id'],
      this.solutionsIsMarketplace
    );
  }

  isVersionPublished(version: any): boolean {
    return !!this.keyValueExists(
      'version_id',
      version['version_id'],
      this.versionInMarketPlace
    );
  }

  solnDesc(solution: any): string {
    const soln = this.getMarketSoln(solution);
    return soln && soln['user_facing_solution_desc']
      ? soln['user_facing_solution_desc']['description'] || ''
      : '';
  }

  deployFor(solution: any): any[] {
    const soln = this.getMarketSoln(solution);
    return soln && soln['deploy_for'] ? soln['deploy_for'] : [];
  }

  verWhen(version: any): string {
    const d = version['updated_dtm'] || version['created_dtm'];
    return d ? 'updated ' + this.snackBar.convertTimeStamp(d) : '';
  }

  findValueByMatchingKey(key: string, value: any, key2: string, data: any) {
    const matchingItem = data.find((item: any) => item[key] === value);
    return matchingItem ? matchingItem[key2] : null;
  }

  openDialogToGenToken(solution: any) {
    const tokenDialog = this.dialog.open(GenSubscriptionKeyComponent, {
      data: {
        solutionDetails: solution,
      },
      panelClass: 'gen-key-dialog',
      width: '600px',
      maxWidth: '94vw',
      disableClose: false,
    });
    tokenDialog.afterClosed().subscribe((result) => {
      if (result) {
        console.info('closed', result);
      }
    });
  }

  openDialogToViewToken(solution: any) {
    this.dialog.open(ViewSubscriptionKeyComponent, {
      disableClose: false,
      panelClass: 'subscribers-dialog',
      width: '600px',
      maxWidth: '94vw',
      data: {solution_id: solution?.solution_id, solution_name: solution?.solution_name},
    });
  }

  openDocsDialog(solution: any, version: any) {
    this.dialog.open(VersionDocsDialogComponent, {
      disableClose: false,
      width: '900px',
      maxWidth: '96vw',
      data: {
        solutionId: solution?.solution_id,
        versionId: version?.version_id,
        solutionName: solution?.solution_name,
        versionName: version?.version_name,
      },
    });
  }
}
